module.exports = __webpack_public_path__ + "static/media/6.15_preview.5c76677c.png";